import * as React from "react";
const SvgArrow = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M11.5 7V15.5M7 12L11.5 16.5L16 12", stroke: "#CCC2C2", strokeWidth: 2, strokeLinecap: "round" }));
export default SvgArrow;
